import React, { Suspense, useState, useEffect, useRef } from "react"; 
import systemListingService from "./SystemListingServices";
import ProjectStatusUpsert from "./upsert/ProjectStatusUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function ProjectStatusListing(param: any) {

  let [editingOn, setEditingOn] = useState(false);
  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  let [openUpsertUX, setOpenUpsertUX] = useState(false); 
  let [editDataDawer, seteditDataDawer] = useState<any>([]);
  let [projectStatus, SetprojectStatus] = useState<any>([]);

  useEffect(() => {

    if (param.activeTab === "Project Status") {
      projectStatusSelect()
    }
  }, [param])

  const projectStatusSelect = () => {

    var payload = {}
    systemListingService.projectStatusList(payload).then((res: any) => { SetprojectStatus(res) })

  }

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }
 
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteProjectStatus(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Project Status delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  } 

  return (
    <div className="content-card ws-12">

      <div className="ptl pbl ws-12">
        <span className="text-bold">Project Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}  >{editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>

        <div className="ws-12 mt">
          <button className="icon-btn primary height35 pull-right fill" onClick={() => openAddDrawer({})} disabled={!editingOn}> Add Project Status  </button>
          <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }}>Save Changes </button>
        </div>

      </div>

      <div className="ws-12">
        <table className={editingOn ? "editing-on newTable" : "newTable"}  >
          <thead>
            <tr>
              <th style={{ width: "18%" }}>Project Status ID</th>
              <th className="col-status text-center">Project Status Name</th>
              <th style={{ width: "18%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {projectStatus.map((row: any) => (
              <tr key={row.statusID}>
                <td>{row.statusID}</td>
                <td >
                  <span style={{
                    background: CommonUtilities.lookUpTypeList('projectStatus', row.statusDescription, 'bgColor'),
                    color: CommonUtilities.lookUpTypeList('projectStatus', row.statusDescription, 'fontColor'),
                    borderRadius: "4px"
                  }} className="pm">
                    {row.statusDescription}
                  </span>
                </td>
                <td >
                  <div>
                    <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(row)} ><i className="icon-pencil"></i> </button>

                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}>
                      <i className="icon-trash"> </i>
                    </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <ProjectStatusUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected project status " + deleteData?.statusDescription} onChange={deleteConfirmation} />
          }
        })()
      }

    </div>
  );
};